import calc from 'calculatorjs'

function selectedFee (selected, fee) {
  return selected === 1 ? fee : 0
}

function normalizeTaiwanAddress (value) {
  return String(value || '').replace(/\s+/g, '').replace(/台/g, '臺')
}

function findHmdeAddl (addrInfo, shippingAddls) {
  const target = normalizeTaiwanAddress(`${addrInfo?.city || ''}${addrInfo?.district || ''}`)
  if (!target) return null

  return (Array.isArray(shippingAddls) ? shippingAddls : [])
    .filter(item => item.saTransport === 'sea' && item.saLabel === 'HMDE')
    .map(item => ({ item, target: normalizeTaiwanAddress(item.saTarget) }))
    .filter(entry => entry.target && target.startsWith(entry.target))
    .sort((a, b) => b.target.length - a.target.length)[0]?.item || null
}

function computeHmdeFee ({ jyoCarrier, addrInfo, shippingAddls }) {
  if (jyoCarrier !== '80_hmde') return 0
  const addl = findHmdeAddl(addrInfo, shippingAddls)
  if (addl) return Number(addl.saFee)
  return 800
}

export function computeAdditionalFees (ctx, policy = {}) {
  const whsInfoFee = ctx.whsInfoFee
  const extraInfo = ctx.form.jyoExtraInfo
  const apartFeePerParcel = policy.apartFeePerParcel || 0
  return {
    timeInsFee: Math.floor(ctx.parcelsFee * 0.05),
    isFsFee: selectedFee(ctx.form.isFs, whsInfoFee.fsFee),
    isCtnFee: selectedFee(ctx.form.isCtn, whsInfoFee.ctnFee),
    isWsFee: selectedFee(ctx.form.isWs, whsInfoFee.wsFee),
    isWbFee: selectedFee(ctx.form.isWb, whsInfoFee.wbFee),
    isWxFee: selectedFee(ctx.form.isWx, whsInfoFee.wxFee),
    isFccFee: selectedFee(ctx.form.isFcc, whsInfoFee.fccFee),
    isOwsuFee: selectedFee(ctx.form.isOwsu, whsInfoFee.owsuFee),
    hmdeFee: computeHmdeFee({
      jyoCarrier: ctx.form.jyoCarrier,
      addrInfo: ctx.addrInfo,
      shippingAddls: ctx.shippingAddls,
    }),
    premiumFee: extraInfo.lostInsAmt > 0
      ? calc.mul(extraInfo.lostInsAmt, 0.01)
      : 0,
    jyoApartFee: extraInfo.apartPclids.length * apartFeePerParcel,
  }
}

export { computeHmdeFee, findHmdeAddl, normalizeTaiwanAddress, selectedFee }

export default computeAdditionalFees
